import { Outlet } from 'react-router-dom'

const ConfigLayout: React.FC = () => {
  return <Outlet />
}

export default ConfigLayout


